"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSService = void 0;
var tslib_1 = require("tslib");
var constants_1 = require("../../constants/constants");
var enums_1 = require("../../enums");
var sdk_1 = require("../../sdk/sdk");
var utils_1 = require("../../utils/utils");
var featureService_1 = require("../features/featureService");
var networkServiceAuth_1 = require("../network/networkServiceAuth");
var networkServiceDefault_1 = require("../network/networkServiceDefault");
var CMSService = /** @class */ (function () {
    function CMSService(networkService) {
        if (networkService === void 0) { networkService = enums_1.NetworkSessionType.DEFAULT; }
        var _a, _b;
        if (!sdk_1.VelvetSDK.appConfig) {
            throw new Error('SDK must be configured before initializing CMSService');
        }
        if (!((_b = (_a = sdk_1.VelvetSDK.Configuration) === null || _a === void 0 ? void 0 : _a.configuration) === null || _b === void 0 ? void 0 : _b.apiEndpointBaseUrl)) {
            throw new Error('API endpoint base URL is not configured');
        }
        this.apiEndpointBaseUrl = sdk_1.VelvetSDK.Configuration.configuration.apiEndpointBaseUrl;
        this.platform = sdk_1.VelvetSDK.appConfig.platform;
        this.networkService =
            networkService === enums_1.NetworkSessionType.AUTH ? new networkServiceAuth_1.NetworkServiceAuth() : new networkServiceDefault_1.NetworkServiceDefault();
        this.featureService = new featureService_1.FeatureService();
    }
    CMSService.prototype.fetchMenu = function (language, country) {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var menuEndpoint, languageOption, countryOption, url, requestable, menuData;
            return tslib_1.__generator(this, function (_c) {
                try {
                    menuEndpoint = (_b = (_a = sdk_1.VelvetSDK.Configuration) === null || _a === void 0 ? void 0 : _a.configuration) === null || _b === void 0 ? void 0 : _b.apiEndpoints.menu;
                    if (!menuEndpoint) {
                        throw new Error('Menu endpoint is not configured');
                    }
                    languageOption = language !== null && language !== void 0 ? language : constants_1.DEFAULT_LANGUAGE;
                    countryOption = country !== null && country !== void 0 ? country : constants_1.EMPTY_STRING;
                    url = menuEndpoint
                        .replace(constants_1.CMS.BASE_URL, this.apiEndpointBaseUrl)
                        .replace(constants_1.CMS.LANGUAGE, languageOption)
                        .concat(constants_1.CMS.PLATFORM, this.platform)
                        .concat(constants_1.CMS.COUNTRY, countryOption);
                    requestable = {
                        url: url,
                        method: constants_1.HTTP_METHOD.GET,
                    };
                    menuData = this.networkService.fetch(requestable);
                    sdk_1.VelvetSDK.CMS.isMenuFetching = false;
                    return [2 /*return*/, menuData];
                }
                catch (error) {
                    console.error('Error fetching menu data:', error);
                    sdk_1.VelvetSDK.CMS.isMenuFetching = false;
                    throw new Error('Failed to fetch the menu data');
                }
                return [2 /*return*/];
            });
        });
    };
    CMSService.prototype.fetchSearchData = function (term, page, itemsPerPage, language) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var searchEndpoint, queryParams, languageOption, url, requestable, searchData, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        searchEndpoint = (_a = sdk_1.VelvetSDK.Configuration.configuration) === null || _a === void 0 ? void 0 : _a.apiEndpoints.search;
                        queryParams = new URLSearchParams({ q: term, page: String(page), perpage: itemsPerPage });
                        languageOption = language !== null && language !== void 0 ? language : constants_1.DEFAULT_LANGUAGE;
                        if (!searchEndpoint) {
                            throw new Error('Search endpoint is not configured');
                        }
                        url = searchEndpoint
                            .replace(constants_1.CMS.BASE_URL, this.apiEndpointBaseUrl)
                            .replace(constants_1.CMS.LANGUAGE, languageOption)
                            .concat("/?".concat(queryParams));
                        requestable = {
                            url: url,
                            method: constants_1.HTTP_METHOD.GET,
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 1:
                        searchData = _b.sent();
                        return [2 /*return*/, searchData];
                    case 2:
                        error_1 = _b.sent();
                        console.error('Error fetching search results:', error_1);
                        throw new Error('Failed to fetch the search results');
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CMSService.prototype.fetchEntitlements = function (videoSlug, language) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var azureBaseUrl, entitlementEndpoint, accessToken, languageOption, url, requestable, _b, data, entitlement, reason, error_2;
            var _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 3, , 4]);
                        azureBaseUrl = (_a = sdk_1.VelvetSDK.Configuration.configuration) === null || _a === void 0 ? void 0 : _a.azureBaseUrl;
                        if (!azureBaseUrl) {
                            throw new Error('Azure base endpoint is not configured');
                        }
                        entitlementEndpoint = "".concat(azureBaseUrl, "/entitlement/").concat(constants_1.CMS.LANGUAGE, "/").concat(constants_1.CMS.SLUG);
                        return [4 /*yield*/, sdk_1.VelvetSDK.Authentication.service.getAccessToken()];
                    case 1:
                        accessToken = _d.sent();
                        languageOption = language !== null && language !== void 0 ? language : constants_1.DEFAULT_LANGUAGE;
                        url = entitlementEndpoint.replace(constants_1.CMS.LANGUAGE, languageOption).replace(constants_1.CMS.SLUG, videoSlug);
                        requestable = {
                            url: url,
                            method: constants_1.HTTP_METHOD.POST,
                            headers: (_c = {},
                                _c[constants_1.X_CLIENT] = constants_1.WEB,
                                _c.Authorization = "Bearer ".concat(accessToken),
                                _c),
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 2:
                        _b = _d.sent(), data = _b.data, entitlement = _b.entitlement, reason = _b.reason;
                        if (entitlement !== constants_1.ALLOWED)
                            throw new Error("".concat(constants_1.NOT_ALLOWED_TO_PLAY, " : ").concat(reason));
                        return [2 /*return*/, data];
                    case 3:
                        error_2 = _d.sent();
                        console.error('Error fetching the video entitlement: ', error_2);
                        throw new Error('Failed to fetch the video entitlement');
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CMSService.prototype.fetchPage = function (pageSlug, subscriptionPlan, profileId, language, country) {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var pageEndpoint, languageOption, countryOption, url, requestable, pageData, shortDetailsResumeWatchingItems, sectionToBeReplaced, error_3;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, , 6]);
                        pageEndpoint = (_b = (_a = sdk_1.VelvetSDK.Configuration.configuration) === null || _a === void 0 ? void 0 : _a.routeData[(0, utils_1.returnStructureParam)(pageSlug)]) === null || _b === void 0 ? void 0 : _b.structure;
                        languageOption = language !== null && language !== void 0 ? language : constants_1.DEFAULT_LANGUAGE;
                        countryOption = country !== null && country !== void 0 ? country : constants_1.EMPTY_STRING;
                        if (!pageEndpoint) return [3 /*break*/, 3];
                        url = pageEndpoint
                            .replace(constants_1.CMS.BASE_URL, this.apiEndpointBaseUrl)
                            .replace(constants_1.CMS.LANGUAGE, languageOption)
                            .concat(constants_1.CMS.PLATFORM, this.platform)
                            .concat(constants_1.CMS.PRODUCT, (0, utils_1.formatString)(subscriptionPlan))
                            .concat(constants_1.CMS.COUNTRY, countryOption);
                        requestable = {
                            url: url,
                            method: constants_1.HTTP_METHOD.GET,
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 1:
                        pageData = _c.sent();
                        return [4 /*yield*/, this.featureService.fetchDetailsShort(profileId, country, language)];
                    case 2:
                        shortDetailsResumeWatchingItems = _c.sent();
                        sectionToBeReplaced = pageData.sections.find(function (section) { return section.cardTemplate === constants_1.CMS_CW_CARD_TEMPLATE; });
                        if (sectionToBeReplaced && shortDetailsResumeWatchingItems) {
                            sectionToBeReplaced.items = shortDetailsResumeWatchingItems;
                        }
                        return [2 /*return*/, pageData];
                    case 3: 
                    // Return undefined if routeData does not exist in order to show "Page not found"
                    return [2 /*return*/, undefined];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_3 = _c.sent();
                        console.error('Error fetching the Page feed: ', error_3);
                        throw new Error('Failed to fetch Page feed data');
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CMSService.prototype.fetchDetails = function (assetType, slug, short, language, country) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var detailsEndpoint, languageOption, countryOption, url, requestable, detailsPageData, error_4;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        detailsEndpoint = (_a = sdk_1.VelvetSDK.Configuration.configuration) === null || _a === void 0 ? void 0 : _a.routeData[constants_1.CMS_ROUTE_DATA.DETAILS].data;
                        languageOption = language !== null && language !== void 0 ? language : constants_1.DEFAULT_LANGUAGE;
                        countryOption = country !== null && country !== void 0 ? country : constants_1.EMPTY_STRING;
                        if (!detailsEndpoint) {
                            throw new Error('Details feed endpoint does not exist');
                        }
                        url = detailsEndpoint
                            .replace(constants_1.CMS.BASE_URL, this.apiEndpointBaseUrl)
                            .replace(constants_1.CMS.LANGUAGE, languageOption)
                            .replace(constants_1.CMS.ASSET_TYPE, assetType)
                            .replace(constants_1.CMS.SLUG, slug)
                            .concat(short ? constants_1.ROUTE.SHORT : constants_1.EMPTY_STRING)
                            .concat(constants_1.CMS.FIRST_QP_COUNTRY, countryOption);
                        requestable = {
                            url: url,
                            method: constants_1.HTTP_METHOD.GET,
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 1:
                        detailsPageData = _b.sent();
                        return [2 /*return*/, detailsPageData];
                    case 2:
                        error_4 = _b.sent();
                        console.error('Error fetching the Details Page: ', error_4);
                        throw new Error('Failed to fetch Details Page data');
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CMSService.prototype.fetchCategoryData = function (resourceType, slug, assetType, language, country) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var categoryEndpoint, languageOption, countryOption, url, requestable, categoryPageData, error_5;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        categoryEndpoint = (_a = sdk_1.VelvetSDK.Configuration.configuration) === null || _a === void 0 ? void 0 : _a.routeData[resourceType].data;
                        languageOption = language !== null && language !== void 0 ? language : constants_1.DEFAULT_LANGUAGE;
                        countryOption = country !== null && country !== void 0 ? country : constants_1.EMPTY_STRING;
                        if (!categoryEndpoint) {
                            throw new Error('Category page endpoint does not exist');
                        }
                        url = categoryEndpoint
                            .replace(constants_1.CMS.BASE_URL, this.apiEndpointBaseUrl)
                            .replace(constants_1.CMS.LANGUAGE, languageOption)
                            .replace(constants_1.CMS.RESOURCE_TYPE, assetType)
                            .replace(constants_1.CMS.SLUG, slug)
                            .concat(constants_1.CMS.FIRST_QP_COUNTRY, countryOption);
                        requestable = {
                            url: url,
                            method: constants_1.HTTP_METHOD.GET,
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 1:
                        categoryPageData = _b.sent();
                        return [2 /*return*/, categoryPageData];
                    case 2:
                        error_5 = _b.sent();
                        console.error('Error fetching the Category Page: ', error_5);
                        throw new Error('Failed to fetch Category Page data');
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CMSService.prototype.fetchRecommendationMovie = function (parentType, slug, language, country) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var recommendationMovieEndpoint, languageOption, countryOption, url, requestable, recommendedMovieData;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        recommendationMovieEndpoint = (_a = sdk_1.VelvetSDK.Configuration.configuration) === null || _a === void 0 ? void 0 : _a.apiEndpoints.resourceRelated;
                        languageOption = language !== null && language !== void 0 ? language : constants_1.DEFAULT_LANGUAGE;
                        countryOption = country !== null && country !== void 0 ? country : constants_1.EMPTY_STRING;
                        if (!recommendationMovieEndpoint) {
                            throw new Error('Recommendation movie endpoint does not exist');
                        }
                        url = recommendationMovieEndpoint
                            .replace(constants_1.CMS.BASE_URL, this.apiEndpointBaseUrl)
                            .replace(constants_1.CMS.LANGUAGE, languageOption)
                            .replace(constants_1.CMS.PARENT_TYPE, parentType)
                            .replace(constants_1.CMS.SLUG, slug)
                            .concat(constants_1.CMS.FIRST_QP_COUNTRY, countryOption);
                        requestable = {
                            url: url,
                            method: constants_1.HTTP_METHOD.GET,
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 1:
                        recommendedMovieData = _b.sent();
                        return [2 /*return*/, recommendedMovieData.data[0]]; //return the first recommended movie from the list
                }
            });
        });
    };
    CMSService.prototype.fetchNextEpisode = function (episodeSlug, parentSlug, parentType, seasonIndex, episodeIndex, language, country) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var nextEpisodeEndpoint, languageOption, countryOption, serieData, url, requestable, nextEpisodeData;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        nextEpisodeEndpoint = (_a = sdk_1.VelvetSDK.Configuration.configuration) === null || _a === void 0 ? void 0 : _a.apiEndpoints.nextEpisode;
                        if (!nextEpisodeEndpoint) {
                            throw new Error('Next episode endpoint does not exist');
                        }
                        languageOption = language !== null && language !== void 0 ? language : constants_1.DEFAULT_LANGUAGE;
                        countryOption = country !== null && country !== void 0 ? country : constants_1.EMPTY_STRING;
                        return [4 /*yield*/, this.fetchDetails(parentType, parentSlug, true, languageOption, countryOption)];
                    case 1:
                        serieData = _b.sent();
                        url = nextEpisodeEndpoint
                            .replace(constants_1.CMS.BASE_URL, this.apiEndpointBaseUrl)
                            .replace(constants_1.CMS.SLUG, episodeSlug)
                            .replace(constants_1.CMS.SEASON_INDEX, seasonIndex.toString())
                            .replace(constants_1.CMS.EPISODE_INDEX, episodeIndex.toString());
                        requestable = {
                            url: url,
                            method: constants_1.HTTP_METHOD.GET,
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 2:
                        nextEpisodeData = _b.sent();
                        return [2 /*return*/, tslib_1.__assign(tslib_1.__assign({}, nextEpisodeData), { parentTitle: serieData.title, parentLogoImg: serieData.contextData.imageTitle, parentDescription: serieData.description, parentImage: serieData.contextData.imageBackdrop, parentSlug: serieData.slug })];
                }
            });
        });
    };
    CMSService.prototype.fetchUserCountry = function () {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userCountryEndpoint, requestable, error_6;
            var _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        if (!((_a = sdk_1.VelvetSDK.Configuration.configuration) === null || _a === void 0 ? void 0 : _a.azureBaseUrl)) {
                            return [2 /*return*/, { countryCode: constants_1.EMPTY_STRING }];
                        }
                        userCountryEndpoint = "".concat((_b = sdk_1.VelvetSDK.Configuration.configuration) === null || _b === void 0 ? void 0 : _b.azureBaseUrl, "/usercountry");
                        requestable = {
                            url: userCountryEndpoint,
                            method: constants_1.HTTP_METHOD.GET,
                            headers: (_c = {},
                                _c[constants_1.X_CLIENT] = constants_1.WEB,
                                _c),
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 1: return [2 /*return*/, _d.sent()];
                    case 2:
                        error_6 = _d.sent();
                        console.error('Error fetching country data:', error_6 === null || error_6 === void 0 ? void 0 : error_6.message);
                        throw new Error("Failed to fetch the country data");
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return CMSService;
}());
exports.CMSService = CMSService;
